import { array, object, string } from 'yup'

import { COMPETENCIES_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [COMPETENCIES_FIELD]: array().of(
      object().shape({
        name: string(),
      }),
    ),
  })
